import { MarketingButtons } from "../../components/MarketingButtons";
import { PageContent } from "../../pages/templates/PageLayout";
import featureCards from "../featureCards";
import Images from "../images";
import { exampleLinks } from "./exampleLinks";

const data: PageContent = {
  style: "light",
  sections: [
    {
      type: "HeroSection",
      title: "Brand management software",
      subtitle: `Ensure brand consistency at scale by creating a team wide hub where everyone can find the assets they need and the guidelines on how to use them.  [See an example](${exampleLinks.brandTeams}).`,
      primaryButton: MarketingButtons.getStarted,
      secondaryButton: MarketingButtons.bookDemo,
      image: {
        src: Images.Solutions.brandTeam_hero,
        alt: "Brand teams",
      },
    },
    {
      type: "MediaSection",
      title: "A single source of truth for your brand",
      subtitle:
        "One location for all your product shots, logos, videos, brand guidelines and any other type of brand asset. ",
      layoutDirection: "image-left",
      body: {
        style: "tabList",
        items: [
          {
            title: "Easy to build",
            body: "Lingo's drag n drop interface and custom branding means you can build your brand hub in days not months.",
            image: {
              src: Images.Solutions.brandTeam_easyToBuild,
              alt: "Easy to build",
            },
          },
          {
            title: "Integrates with Figma",
            body: "Assets created in Figma can be synced to Lingo so you can build style guides and asset libraries that can be used by your entire organization",
            image: {
              src: Images.Solutions.brandTeam_figmaIntegration,
              alt: "Integrates with Figma",
            },
          },
          {
            title: "Private and public sharing",
            body: "Keep your brand hub private so only people with permission can have access, or make your hub public so anyone with the link can have access - no account required.",
            image: {
              src: Images.Solutions.brandTeam_publicSharing,
              alt: "Private and public sharing",
            },
          },
          {
            title: "Automatic file conversion",
            body: "Have an SVG but need a PNG? Lingo auto-generates alternate file types of every asset you put in. No more time wasted on requests to export assets for different file types.",
            image: {
              src: Images.Solutions.brandTeam_fileConversion,
              alt: "Automatic file conversion",
            },
          },
        ],
      },
    },
    {
      type: "CardSection",
      title: "More powerful features to manage your assets",
      footerButton: {
        link: "/product/features",
        text: "View all features",
        buttonStyle: "outline",
      },
      items: [featureCards.customBranding, featureCards.customDomains, featureCards.insights],
    },
    {
      type: "FaqSection",
      title: "Brand Team FAQs",
      faqs: [
        {
          question: "How does Lingo help ensure brand consistency across teams?",
          answer:
            "Lingo connects digital brand guidelines with assets in one centralized hub, making it easy for teams to find, use, and share approved content. With metadata tagging, version control, and automatic file conversions, you can ensure that every asset is used the right way, every time.",
        },
        {
          question: "Can non-design teams easily access and use brand assets?",
          answer:
            "Yes! Lingo's intuitive, self-serve portal allows marketing, sales, and other teams to access the right assets without needing design expertise. No more file requests or off-brand materials, just the right content in the right format, instantly.",
        },
        {
          question: "How does Lingo help us track how brand assets are being used?",
          answer:
            "Lingo's analytics dashboard provides insights into which assets are being accessed and downloaded most, helping brand teams understand what’s working and optimize content for better consistency and impact.",
        },
        {
          question: "How does Lingo compare to traditional DAMs?",
          answer:
            "Unlike bloated, overly complex DAMs, Lingo is built specifically for brand teams. It combines digital asset management with brand governance on a flexible canvas, ensuring guidelines and assets live together in an easy-to-use, searchable platform.",
        },
        {
          question: "Can we update assets in Lingo without breaking external links?",
          answer:
            "Absolutely! When you update an asset in Lingo, it automatically syncs across shared kits and portals so teams, agencies, and partners always have access to the latest version without needing to resend links.",
        },
        {
          question: "Does Lingo integrate with the design and storage tools we already use?",
          answer:
            "Yes! Lingo integrates with Canva, Figma, Google Drive, Dropbox, and other tools, allowing your teams to sync and manage assets without disrupting existing workflows.",
        },
        {
          question: "Can we control who has access to different assets?",
          answer:
            "Yes! Lingo provides flexible permissions, allowing you to grant access at the user, team, or kit level. You can also set up public, private, or password-protected links, ensuring only the right people can access specific files.",
        },
      ],
    },
    { type: "CtaSection" },
  ],
};

export default data;
